






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Result } from '@/models/dynamiclist';

@Component({})
export default class DynamicTableResultComponent extends Vue {
    @Prop({ required: true })
    public results!: Result[];

    @Prop({ required: true })
    public tableFields!: any;
}
